import styled from 'styled-components'
import { INTER } from '../../styles/fonts'
import { CERULEAN_BLUE } from '../../styles/colors'

export const Container = styled.div`
  font-family: ${INTER.semiBold};
  font-size: 13px;
  color: ${CERULEAN_BLUE};
  background-image: linear-gradient(to bottom, #FFFFFF, #F0F0F0);
  border: 2px solid #F0F0F0;
  border-radius: 6px;
  padding: 2px 10px;
` as any
